import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";
import { IFilter } from "../Tools/IFilter";

export class MagicSearchFilter implements IFilter {
    id: string;
    name?: string | null;
    type: string;
    parentGroup: FilterGroup;
    controller: FiltersController;
    constructor(parentGroup: FilterGroup) {
        this.parentGroup = parentGroup;
        this.id = 'magicsearch';
        this.name = 'Recherche';
        this.type = 'magicsearch';
        this.controller = new FiltersController();
    }


    html(): string {
        let html = `
        <div class="filter" style="max-width: 380px;width: 100%;margin:0 auto;">
            <span>${this.name}</span>
            <input id="magicSearch" style="max-width: 380px;width: 100%;margin:0 auto;height : 100%;border:1px solid #ccc; height: 30px;"
                type="text">
        </div>
        `;

        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            if (!this.controller) {
                console.error('FiltersWidget.controller is not defined');
                return;
            }
            this.controller.addEventListener('input', () => {
                let selectedValue = $('#magicSearch').val() as string;
                if (selectedValue === '') {
                    FilterGroup.filters.magicsearch = null;
                }
                else {
                    FilterGroup.filters.magicsearch = selectedValue;
                }
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
            }, 'magicSearch');

        }, 50);

        return html;
    }

    destroy(): void {
        this.controller.destroy();
    }

}